<template>
  <div>
    <draggable
      tag="ul"
      :list="children"
      :group="{ name: 'g1' }"
      class="dragArea"
      :class="{ controls: !attrs.compact }"
    >
      <li
        v-for="(el, index) in children"
        :key="`${el.id}-${el.name}-${index}`"
        class="no-style mt-1"
      >
        <!-- View mode    -->
        <div v-if="!el.edit">
          <ColHeader :el="el" :attrs="attrs" :depth-inc="depthInc" />
          <ColCard :el="el" :attrs="attrs" />
        </div>
        <!-- Edit mode    -->
        <v-row v-if="el.edit" dense class="my-0">
          <ColHeader :el="el" :attrs="attrs" />
          <v-col cols="12">
            <ItemForm
              class="pb-4"
              :key="`${newItem.id}-${el.id}`"
              :new-item="newItem"
              :colors="colors"
              :attrs="attrs"
              :categories="attrs.categories"
              :local="{ obj: attrs.listOne }"
              @submit="editCommit"
              @cancel="cancelEdit"
            />
          </v-col>
        </v-row>

        <v-row v-if="!el.edit" dense class="my-0 pb-2">
          <v-col cols="12">
            <div
              v-if="attrs.controls"
              class="d-flex justify-end align-center flex-wrap pr-4"
            >
              <v-btn @click="editItem(el)" x-small color="white" class="" light
                >Edit</v-btn
              >
              <v-btn
                @click="cloneItem(el)"
                x-small
                color="white"
                class="ml-2"
                light
                >Clone</v-btn
              >

              <v-btn
                class="ml-2"
                @click="deleteItem(el)"
                x-small
                color="white"
                light
                >Delete</v-btn
              >
            </div>
          </v-col>
        </v-row>

        <v-row v-show="attrs.nesting" dense class="my-0">
          <v-col cols="12">
            <NestedDraggable
              :children="el.children"
              :attrs="attrs"
              :depth="depthInc"
              :color="el.color"
              :label="el.label"
              :local="attrs.local"
            /> </v-col
        ></v-row>
      </li>
    </draggable>
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete this item?</v-card-title
        >

        <v-card-actions>
          <v-btn color="amber" text @click="deleteConfirm">
            Yes
          </v-btn>
          <v-btn color="amber" text @click="deleteCancel">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ItemForm from "@/views/user/exercises/logic-system/ItemForm";
import ColCard from "@/views/user/exercises/logic-system/ColCard";
import ColHeader from "@/views/user/exercises/logic-system/ColHeader";
// import { checkPopulated } from "@/utils/types";

import {
  itemModel,
  colors,
  initialState,
  createItem,
  customColumns,
} from "./model";

export default {
  name: "NestedDraggable",
  data() {
    return {
      edit: false,
      newItem: {
        ...itemModel,
      },
      dialog: false,
      depthInc: this.depth + 1,
      colors: colors,
    };
  },
  components: {
    draggable,
    ItemForm,
    ColCard,
    ColHeader,
  },
  props: {
    children: {
      required: true,
      type: Array,
      default: () => [],
    },
    hideChildren: {
      type: Boolean,
      default: false,
    },
    attrs: Object,
    local: Object,
    depth: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: "",
    },
    id: {
      type: Number,
      default: null,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    computedSize() {
      if (this.attrs.type === "large") {
        return "text-h5";
      }
      if (this.attrs.type === "medium") {
        return "text-h6";
      }
      if (this.attrs.type === "small") {
        return "text-body-1";
      }
      if (this.attrs.type === "waterfall") {
        switch (this.depthInc) {
          case 1:
            return "text-h4";
          case 2:
            return "text-h5";
          case 3:
            return "text-body-1";
          default:
            return "text-body-2";
        }
      }
      return "text-h5";
    },
  },
  methods: {
    getButtonText(el) {
      return el.allowPrefix ? "Prefix on" : "Prefix off";
    },
    getButtonClass(el) {
      return el.allowPrefix ? "white" : "grey lighten-2";
    },
    editItem($event) {
      const pick = this.children.find((x) => x.id === $event.id);
      const indexOfItem = this.children.indexOf(pick);
      this.$set(this.children, indexOfItem, pick);
      // first reset
      Object.assign(this.newItem, initialState());
      // then make = to event
      Object.assign(this.newItem, { ...$event });
      this.$nextTick(() => {
        pick.edit = true;
      });
    },
    editCommit($event) {
      const item = this.children.find((x) => x.id === $event.id);
      const indexOfItem = this.children.indexOf(item);
      const editedItem = this.constructItem(itemModel, $event);
      editedItem.edit = false;
      this.$set(this.children, indexOfItem, editedItem);
    },
    deleteItem($event) {
      this.dialog = true;
      this.candidate = $event;
    },
    deleteCancel() {
      this.dialog = false;
      this.candidate = false;
    },
    deleteConfirm() {
      const item = this.children.find((x) => x.id === this.candidate.id);
      const indexOfItem = this.children.indexOf(item);
      this.children.splice(indexOfItem, 1);
      this.candidate = null;
      this.dialog = false;
      this.$emit("deleteChildren", { item: item.id, list: this.children });
    },

    cancelEdit($event) {
      const item = this.children.find((x) => x.id === $event.id);
      const indexOfItem = this.children.indexOf(item);
      const editedItem = {
        ...item,
        edit: false,
      };
      this.$set(this.children, indexOfItem, editedItem);
    },
    cloneItem($event) {
      const item = { ...this.children.find((x) => x.id === $event.id) };
      item.id = new Date().valueOf();
      item.edit = false;
      const clonedItem = this.constructItem(itemModel, item);
      this.children.push(clonedItem);
    },
    constructItem(model, item) {
      const a = createItem(item, model);
      const b = customColumns(this?.attrs?.listOne, item);
      return { ...a, ...b };

      // const obj = {};
      // Object.keys(model).forEach((key) => {
      //   obj[key] = checkPopulated(item[key]);
      // });
      // console.log("constructItem", this.attrs);
      // const arr = this?.attrs?.listOne;
      // const cols = this.customCols(arr, item);
      // return { ...obj, ...cols };
    },
    destroyProto() {
      // console.log("destroy proto");
      // this.newItem = { ...itemModel };
      // this.newItem.motivations.length = 0;
      // this.newItem.categories.length = 0;
      // this.newItem.children.length = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.circle {
  width: 30px;
  height: 30px;
  max-width: 30px;
  max-height: 30px;
  background: grey;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
}
.pre-wrap {
  white-space: pre-wrap;
}
.dragArea.controls {
  border: 1px dotted #333333;
  min-height: 4rem;
}
.dragArea {
  padding: 4rem;

  // background: rgba(0, 0, 0, 0.02);

  li {
    list-style: none;
    background: white;
    padding-left: 1rem;
    background: white;
    margin: 0px 0 0px 0;
    background: rgb(240, 240, 240);
    padding-right: 0rem;
    cursor: pointer;
    border-top: white 1px dotted;
    border-left: white 4px solid;
    ul {
      li {
        background: rgb(230, 230, 230);
        ul {
          margin-bottom: 0px;
          li {
            background: rgb(220, 220, 220);
          }
          ul {
            li {
              background: rgb(210, 210, 210);
            }
            ul {
              li {
                background: rgb(200, 200, 200);
              }
              ul {
                li {
                  background: rgb(190, 190, 190);
                }
              }
            }
          }
        }
      }
    }
  }
  padding: 0;
  margin: 0px;
  // margin-bottom: 0.5rem;
}
</style>
